import { Component, Inject } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

export interface OrderPreviewData {
  orderId?: string | number;
  tableLabel?: string;
  customerName?: string;
  since?: Date | string;
  status?: string;
  groups: Array<{ name: string; qty: number; options?: Array<{ name: string; qty: number }> }>;
}

@Component({
  selector: 'app-order-preview-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule, DatePipe],
  template: `
    <h2 mat-dialog-title class="header">
      <mat-icon class="mr">receipt_long</mat-icon>
      <span>Orden #{{ data.orderId || '—' }}, {{ data.customerName || 'Sin nombre' }}</span>
    </h2>

    <div mat-dialog-content class="content">
      <div class="meta">
        <div *ngIf="data.tableLabel"><strong>Mesa:</strong> {{ data.tableLabel }}</div>
        <div *ngIf="data.since"><strong>Desde:</strong> {{ data.since | date:'short' }}</div>
        <div *ngIf="data.status"><strong>Estado:</strong> <span class="badge">{{ data.status | uppercase }}</span></div>
      </div>

      <div class="groups">
        <div class="group" *ngFor="let g of data.groups">
          <div class="group-head">
            <span class="qty">{{ g.qty }}×</span>
            <span class="name">{{ g.name }}</span>
          </div>
          <div class="options" *ngIf="g.options?.length">
            <div class="opt" *ngFor="let op of g.options">{{ op.qty }} × {{ op.name }}</div>
          </div>
        </div>
      </div>
    </div>

    <div mat-dialog-actions align="end">
      <button mat-stroked-button color="primary" (click)="close()">Cerrar</button>
    </div>
  `,
  styles: [`
    .header { display: flex; align-items: center; }
    .mr { margin-right: 8px; }
    .content { min-width: 420px; }
    .meta { color: #555; display: grid; gap: 4px; margin-bottom: 12px; }
    .badge { display: inline-block; padding: 2px 8px; background: #eee; border-radius: 12px; font-size: 12px; }
    .groups { display: grid; gap: 10px; }
    .group-head { display: flex; align-items: center; gap: 8px; font-weight: 600; }
    .qty { color: #1976d2; }
    .options { margin-left: 22px; color: #666; font-size: 13px; }
  `]
})
export class OrderPreviewDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: OrderPreviewData,
    private ref: MatDialogRef<OrderPreviewDialogComponent>,
  ) { }
  close() { this.ref.close(); }
}